import { SiteMeta } from '@src/types/SiteMeta';
import storeConnector from '@store/storeConnector';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CommandsCategory } from '@src/types/Commands';
import PCS from '@components/Battery/Powin/Commands/PowinBess/PCS';
import DCContactor from '@components/Battery/Powin/Commands/PowinBess/DCContactor';
import FaultReset from '@components/Battery/Powin/Commands/PowinBess/FaultReset';
import { CommandsModalContextProvider } from '../CommandsModalContext';
import useAlias from '@alias';

const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const btnContainer = {
  marginBottom: '15px',
};

interface Props {
  powinControllerName: string;
  open: boolean;
  bessId: string;
  bessName: string;
  onClose: () => void;
  siteMeta: SiteMeta;
}

function PowinBessCommandsModal({
  powinControllerName,
  open,
  bessId,
  bessName,
  onClose,
  siteMeta,
}: Props) {
  const alias = useAlias();

  return (
    <CommandsModalContextProvider
      category={CommandsCategory.POWINBESS}
      deviceId={siteMeta.siteId}
      defaultParams={{
        POWINBESS: bessId?.split('_').pop(),
      }}
    >
      <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
        <StyledDialogTitle>
          {powinControllerName} {bessName} {alias('Controls')}
          <IconButton onClick={onClose} sx={{ mr: -2, mt: -1 }}>
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>
        <DialogContent dividers>
          <Box sx={{ mt: 1 }}>
            <div style={btnContainer}>
              <PCS />
            </div>
            <div style={btnContainer}>
              <DCContactor />
            </div>
            <div style={btnContainer}>
              <FaultReset />
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    </CommandsModalContextProvider>
  );
}

export default storeConnector(PowinBessCommandsModal, {
  config: ['siteMeta'],
});
